// extracted by mini-css-extract-plugin
export default {"info":"HLFJle5FfxmHvrE3LMHB","contact":"ZtaLymUd0X6BDZWUtNJC"};